import * as z from 'zod';
import { DayJsSchema, EntityId, Tag } from './base-schemas';
import { BookingModel } from './Booking';
import { CategoryModel, EnrichedCategory } from './Category';
import { smallIntToBoolean, stringToNumber } from './base-codecs';
export const PositionModel = z.object({
    _tag: Tag('PositionModel'),
    id: EntityId,
    category_id: EntityId,
    remarks: z.string().nullable(),
    map_x: stringToNumber,
    map_y: stringToNumber,
    map_name: z.string(),
    full_name: z.string(),
    full_name_en: z.string().nullable(),
    is_bookable_online: smallIntToBoolean,
    is_bookable_self_checkin: smallIntToBoolean,
    is_bookable_bookvisit: smallIntToBoolean,
    allows_auto_checkout: smallIntToBoolean,
    is_dropin: smallIntToBoolean,
    is_reserve: smallIntToBoolean,
    max_dogs: z.number().nullable(),
    height: stringToNumber,
    width: stringToNumber,
    rotation: z.number(),
    border_radius: stringToNumber,
    display_order: z.number(),
    replaced_by: z.number().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
    deleted_at: z.string().nullable(),
    // Attributes
    icon: z.string().optional(),
    color: z.string().optional(),
    avatar: z.any().optional(),
    has_tally_electric_meter: z.boolean().optional(),
    has_webel_electric_meter: z.boolean().optional(),
    custom_informations: z.any().optional(),
    status_text: z.string().optional(),
    next_booking: z.any().optional(),
    is_tally_cabin: z.boolean().optional(),
    cabin_climate: z.object({
        preheat_hours: z.number().nullable(),
        unoccupied_temperature: z.number().nullable(),
        occupied_temperature: z.number().nullable(),
        last_temperature: z.number().nullable(),
        temperature_read_at: z.string().nullable()
    }).nullish(),
    booking_periods: z.any().optional(),
    // Relations (when loaded)
    get bookings() { return z.array(BookingModel).nullish(); },
    get category() { return CategoryModel.nullish(); }
});
export const EnrichedPosition = PositionModel.extend({
    _tag: Tag('EnrichedPosition'),
    isEnriched: z.literal(true),
    category: EnrichedCategory.optional(),
    width_percent: z.string(),
    height_percent: z.string(),
    border_radius_percent: z.string(),
    svg_rect_id: z.string(),
    svg_rect_rx: z.string(),
    svg_rect_clip_path_id: z.string(),
    svg_rect_clip_path_href: z.string(),
    svg_clip_path_id: z.string(),
    svg_text_x: z.string(),
    svg_text_y: z.string(),
    svg_text_clip_path: z.string(),
    svg_polygon_clip_path: z.string(),
    timestampLastPositionRemarkUpdate: DayJsSchema.optional()
});
